import { Outlet, NavLink, Navigate } from 'react-router-dom';

const navItems = [
  { to: '/portal', label: 'Home', end: true },
  { to: '/portal/bookings', label: 'My bookings' },
  { to: '/portal/invoices', label: 'My invoices' },
  { to: '/portal/messages', label: 'Messages' },
  { to: '/portal/profile', label: 'Profile' },
];

export function PortalLayout() {
  if (typeof window !== 'undefined' && !localStorage.getItem('frontdesk-portal-token')) {
    return <Navigate to="/portal/login" replace />;
  }
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--color-surface-secondary)' }}>
      <nav
        style={{
          width: 200,
          padding: 'var(--space-4)',
          background: 'var(--color-surface-primary)',
          borderRight: '1px solid var(--color-border-primary)',
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-1)',
          position: 'sticky',
          top: 0,
          height: '100vh',
        }}
      >
        <div style={{ fontWeight: 700, padding: 'var(--space-3) var(--space-2)' }}>Portal</div>
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            style={({ isActive }) => ({
              padding: 'var(--space-2) var(--space-3)',
              borderRadius: 'var(--radius-md)',
              color: isActive ? 'var(--color-brand-primary)' : 'var(--color-text-secondary)',
              background: isActive ? 'var(--color-brand-primary-light)' : 'transparent',
              textDecoration: 'none',
              fontSize: 'var(--text-sm)',
              fontWeight: isActive ? 600 : 400,
            })}
          >
            {item.label}
          </NavLink>
        ))}
        <button
          onClick={() => {
            localStorage.removeItem('frontdesk-portal-token');
            window.location.href = '/portal/login';
          }}
          style={{
            marginTop: 'auto',
            padding: 'var(--space-2) var(--space-3)',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'var(--text-sm)',
            color: 'var(--color-text-tertiary)',
            textAlign: 'left',
          }}
        >
          Sign out
        </button>
      </nav>
      <main style={{ flex: 1, padding: 'var(--space-6)' }}>
        <Outlet />
      </main>
    </div>
  );
}
